module.exports = __webpack_public_path__ + "img/FR30051.7bc7f6ad.png";